/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { useIconState } from '@mpb-com/feather/components/atoms/icon';
import { InteractionState } from '@mpb-com/feather/components/atoms/icon/types';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import InnerHeart from '@toucan/client/global/icons/heart-inner.svg';
import HeartOutline from '@toucan/client/global/icons/heart-outline.svg';
import HeartWaves from '@toucan/client/global/icons/heart-waves.svg';

import { styles } from './heart.styles';

export type HeartProps = {
    className?: string;
};

type StyledHeartContainerProps = {
    $isToggled: boolean;
    $isHover: boolean;
};

const StyledHeartContainer = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})<StyledHeartContainerProps>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    ${styles}
`;

export const Heart: FunctionComponent<HeartProps> = ({
    className,
}: HeartProps) => {
    const { interactionState, isToggled } = useIconState();
    const isHover = interactionState === InteractionState.HOVER;

    return (
        <StyledHeartContainer
            $isToggled={isToggled}
            $isHover={isHover}
            className={className}
        >
            <HeartOutline className="heart-outline" />
            <InnerHeart className="heart-inner" />
            <HeartWaves className="heart-waves" />
        </StyledHeartContainer>
    );
};
